import React from 'react';
import { Grid, Paper, Typography, styled } from '@mui/material';
import { motion } from 'framer-motion';

// Sample icons (replace with your preferred icon library)
import DocumentIcon from '@mui/icons-material/DocumentScanner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ErrorIcon from '@mui/icons-material/Error';

// Static data for the cards
const cardData = [
  { title: 'No of PO', value: '5', icon: <DocumentIcon /> },
  { title: 'No of GRN', value: '3', icon: <CheckCircleIcon /> },
  { title: 'No of Invoice', value: '7', icon: <ReceiptIcon /> },
  { title: 'No of Failure GRN', value: '2', icon: <ErrorIcon /> },
  { title: 'No of Failure Invoice', value: '1', icon: <ErrorIcon /> },
];

// Styled card component
const CardWrapper = styled(motion.div)(({ theme }) => ({
  padding: '24px',
  textAlign: 'center',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
  },
  cursor: 'pointer',
}));

// Card component
function Card({ title, value, icon }) {
  return (
    <CardWrapper
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Typography
        variant="h6"
        style={{
          fontWeight: 500,
          color: '#2d3748',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
        }}
      >
        {icon} {title}
      </Typography>
      <Typography
        variant="h4"
        style={{
          fontWeight: 700,
          color: '#48bb78', // Green for values; adjust per metric if needed
        }}
      >
        {value}
      </Typography>
    </CardWrapper>
  );
}

// Dashboard component
function Dashboard() {
  return (
    <div
      style={{
        padding: '32px',
        // background: 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)', // Modern gradient
        minHeight: '100vh',
      }}
    >
      <Typography
        variant="h4"
        style={{
          fontWeight: 600,
          color: '#667eea',
          marginBottom: '32px',
        }}
      >
        Dashboard
      </Typography>
      <Grid container spacing={4} justifyContent="flex-start">
        {cardData.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card title={card.title} value={card.value} icon={card.icon} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Dashboard;